<template>
  <div class="">
    <div class="row">
      <div class="col-12 col-md-5">
        <documents-send-mail-form
          :documentData="purchasesOrder"
          :dispatchUrl="'purchasesOrders/sendMail'"
          :toggleMailModal="toggleMailModal"
          :mailInformation="mailInformation"
        />
      </div>
      <div
        class="col-12 col-md-7"
        style="max-height: 550px; overflow-y: scroll"
      >
        <purchases-order-view-details
          :showHeader="false"
          :purchasesOrder="purchasesOrder"
          @purchasesOrderItemsUpdated="get"
        />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <el-button type="danger" @click="toggleMailModal">
        {{ $t("COMMON.CANCEL") }}
      </el-button>
    </div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import "flatpickr/dist/flatpickr.css";
import formMixin from "@/mixins/form-mixin";
import DocumentsSendMailForm from "@/components/DocumentsSendMailForm";
import PurchasesOrderViewDetails from "./PurchasesOrderViewDetails";

export default {
  layout: "DashboardLayout",
  name: "sales-order-mail-modal-content",

  components: {
    DocumentsSendMailForm,
    PurchasesOrderViewDetails,
    [Button.name]: Button,
  },

  mixins: [formMixin],
  props: {
    purchasesOrder: {
      default: () => {},
    },
    toggleMailModal: {
      type: Function,
    },
    get: {
      type: Function,
    },
    loading: {
      default: () => true,
    },
  },

  data() {
    return {
      submitting: false,
      mailInformation: {
        organization: {},
        recipient: {},
        user: {},
      },
    };
  },

  created() {},

  mounted() {
    this.mailInformation = {
      organization: this.purchasesOrder?.organization,
      subject: this.$t("COMMON.EMAIL_INFOS_SUBJECT_ORDER", {
        organization: this.purchasesOrder?.organization?.name,
        code: this.purchasesOrder.code,
      }),
      recipient: {
        username: this.purchasesOrder?.issuer?.customer_name,
        email: this.purchasesOrder?.issuer?.email,
      },
    };
  },

  methods: {},

  watch: {
    purchasesOrder(purchasesOrder) {
      this.mailInformation = {
        organization: purchasesOrder.organization,
        subject: this.$t("COMMON.EMAIL_INFOS_SUBJECT_ORDER", {
          organization: purchasesOrder.organization?.name,
          code: purchasesOrder.code,
        }),
        recipient: {
          username: purchasesOrder?.issuer?.customer_name,
          email: purchasesOrder?.issuer?.email,
        },
      };
    },
  },
};
</script>
